import { Controller } from "@hotwired/stimulus"

// Handles the header menu toggle functionality
export default class extends Controller {
  static targets = ["menu", "hamburger", "close", "button"]

  connect() {
    // Ensure initial state is correct
    this.closeMenu()
    
    // Store bound functions for cleanup
    this.clickOutsideHandler = this.clickOutside.bind(this)
    this.handleResizeHandler = this.handleResize.bind(this)
    
    // Close menu when clicking outside
    document.addEventListener("click", this.clickOutsideHandler)

    // Close menu when screen size changes to desktop
    window.addEventListener("resize", this.handleResizeHandler)
  }

  disconnect() {
    // Clean up event listeners
    document.removeEventListener("click", this.clickOutsideHandler)
    window.removeEventListener("resize", this.handleResizeHandler)
  }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.openMenu()
    } else {
      this.closeMenu()
    }
  }

  openMenu() {
    this.menuTarget.classList.remove("hidden")
    this.hamburgerTarget.classList.add("hidden")
    this.closeTarget.classList.remove("hidden")
  }

  closeMenu() {
    this.menuTarget.classList.add("hidden")
    this.hamburgerTarget.classList.remove("hidden")
    this.closeTarget.classList.add("hidden")
  }

  clickOutside(event) {
    if (!this.element.contains(event.target) && !this.menuTarget.classList.contains("hidden")) {
      this.closeMenu()
    }
  }

  handleResize() {
    if (window.innerWidth >= 768 && !this.menuTarget.classList.contains("hidden")) {
      this.closeMenu()
    }
  }
} 